import { Injectable,PLATFORM_ID,Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitConfigService {

  constructor(
    @Inject(PLATFORM_ID) private platformId: string, 
    private configService:ConfigurationService,
    @Inject('env') private env: any) { }
    /**
     * Old implementation with env passed in.
     */
 /*  Init(env){
    if (isPlatformBrowser(this.platformId)) {
      return new Promise<void>((resolve, reject) => {
        setTimeout(() => {
          this.configService.setSiteConfig(env);
            resolve();
        }, 500);

    });
    }
  } */
    /**
     * Without env.  
     * @returns A promise which resolves after setting the site configuration
     */
  Init() {
    if (isPlatformBrowser(this.platformId)) {
      return new Promise<void>((resolve) => {
        setTimeout(() => {
          this.configService.setSiteConfig(this.env);
          resolve();
        }, 500);
      });
    }
    return Promise.resolve();
  }
}
